/* global axios */

const getBaseUrl = (accountId, contactId) =>
  `/api/v1/accounts/${accountId}/contacts/${contactId}/contact_documents`;

export default {
  getAll(accountId, contactId) {
    return axios.get(getBaseUrl(accountId, contactId));
  },

  upload(accountId, contactId, files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files[]', file);
    });
    return axios.post(getBaseUrl(accountId, contactId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  rename(accountId, contactId, documentId, fileName) {
    return axios.patch(`${getBaseUrl(accountId, contactId)}/${documentId}`, {
      file_name: fileName,
    });
  },

  delete(accountId, contactId, documentId) {
    return axios.delete(`${getBaseUrl(accountId, contactId)}/${documentId}`);
  },

  downloadUrl(accountId, contactId, documentId) {
    return `${getBaseUrl(accountId, contactId)}/${documentId}/download`;
  },
};
